import { IFetchConfig } from "@/lib/http/interfaces/IFetchConfig"

export interface IContentServiceClientConfig extends IFetchConfig {}

const contentServiceApiBaseUrl =
    process.env.CONTENT_SERVICE_API_BASE_URL ||
    process.env.NEXT_PUBLIC_CONTENT_SERVICE_API_BASE_URL ||
    "https://poc-ecommerce-api-929004252109.europe-north1.run.app"

export const contentServiceConfigFactory = (
    config: { baseUrl: string } = { baseUrl: "" }
): IContentServiceClientConfig => ({
    baseUrl: config.baseUrl
})

export const contentServiceClientConfig: IFetchConfig = contentServiceConfigFactory({
    baseUrl: contentServiceApiBaseUrl
})
